import { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFetch from "../../../hook/useFetch"
import { useLocation } from "react-router-dom"
import { fileActions } from "../../../store/files-slice";
import { notificationActions } from "../../../store/notification-slice";
import useFilter from "../../../hook/useFilter";
import useIsMobile from "../../../hook/useIsMobile";
import MobileComponent from "./datatable/mobile";
import DesktopComponent from "./datatable/desktop";
import Skeleton from "react-loading-skeleton";

export default function Files() {

    const [files, setFiles] = useState()

    const { get } = useFetch()

    let dispatch = useDispatch()

    let location = useLocation()

    const { convertToArray } = useFilter()

    const { isMobile } = useIsMobile()


    const fetchFiles = () => {
        setFiles(null)
        dispatch(fileActions.resetFiles())
        get(`/admin/files`, null, (data) => {
            dispatch(notificationActions.setNotification({
                message: data,
                status: false
            }))
        }, (data) => {
            data = convertToArray(data)
            setFiles(data)
            dispatch(fileActions.setFiles(data))

        })
    }

    useEffect(() => {
        fetchFiles()
    },[])

    useEffect(() => {
        if (location.state && location.state.refetch) {

            fetchFiles()
        }
    }, [location.state])


    if(!files){
        return <Skeleton count={50} />
    }


    return <div className="rso-pages card shadow  bg-white rounded p-3 m-0">{isMobile ? <MobileComponent /> : <DesktopComponent />}</div>
}